import template from "./deployments.html";
import controller from "./deployments.controller";

const DeploymentsComponent = {
	template,
	controller,
	controllerAs: "controller"
};

export default DeploymentsComponent;


// WEBPACK FOOTER //
// ./sources/components/deployments/deployments-component.js